import React, { useMemo, useEffect, useState, useCallback } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { AuthingButton } from "../../../../components/AuthingButton";
import { Link } from "../../../../components/LinkIcon";

const isWindow = () => typeof window !== "undefined";
const isDocument = () => typeof document !== "undefined";
export const ManufacturingAdvantage = () => {
  const { t } = useTranslation();
  const list = useMemo(() => {
    return [
      {
        title: t("car.advantage.item1.title"),
        desc: t("car.advantage.item1.desc"),
        imgUrl: "https://files.authing.co/authing-website/car-question1.png",
        alt: t("car.advantage.item1.alt"),
        downText: t("common.how-use"),
        downUrl: "https://www.authing.cn/authorization-management",
      },
      {
        title: t("car.advantage.item2.title"),
        desc: t("car.advantage.item2.desc"),
        imgUrl: "https://files.authing.co/authing-website/car-question2.png",
        alt: t("car.advantage.item2.alt"),
        downText: t("common.button.learn-more"),
        downUrl:
          "https://docs.authing.cn/v2/multi-tenant-console/#%E5%A4%9A%E7%A7%9F%E6%88%B7%E6%8E%A7%E5%88%B6%E5%8F%B0",
      },
      {
        title: t("car.advantage.item3.title"),
        desc: t("car.advantage.item3.desc"),
        imgUrl: "https://files.authing.co/authing-website/car-question3.png",
        alt: t("car.advantage.item3.alt"),
        downText: t("common.button.learn-more"),
        downUrl: "https://www.authing.cn/solutions/ad",
      },
      {
        title: t("car.advantage.item4.title"),
        desc: t("car.advantage.item4.desc"),
        imgUrl: "https://files.authing.co/authing-website/car-question4.png",
        alt: t("car.advantage.item4.alt"),
        downText: t("common.button.linkDoc"),
        downUrl: "https://docs.authing.cn/v2/guides/sync-new/",
      },
    ];
  }, [t]);
  const [topValue, setTopValue] = useState("0px");
  const [bottomValue, setBottomValue] = useState();
  const [scrollTop, setScrollTop] = useState(0);
  const [bannerIndex, setBannerIndex] = useState(0);
  const scrollHandler = useCallback(() => {
    if (isDocument()) {
      const chrildElement =
        isDocument() && document.querySelector(".bannerBox-right-chrild");
      const documentScrollTop =
        (isDocument() && document.body.scrollTop) ||
        document.documentElement.scrollTop;
      const selfHeight =
        isWindow() &&
        Number(window.getComputedStyle(chrildElement).height.split("px")[0]);
      if (topValue < documentScrollTop) {
        const index = Math.round((documentScrollTop - topValue) / selfHeight);
        if (index < list.length) {
          setBannerIndex(index);
        }
      }
      setScrollTop(documentScrollTop);
    }
  });
  const [element, setElement] = useState(0);
  useEffect(() => {
    scrollHandler();
  }, [scrollHandler]);
  useEffect(() => {
    isWindow() && window.addEventListener("scroll", scrollHandler);
    return () => {
      isWindow() && window.removeEventListener("scroll", scrollHandler);
    };
  }, [scrollHandler]);
  useEffect(() => {
    if (isWindow()) {
      const bannerBox = document.getElementById("bannerBox");
      if (bannerBox) {
        setTopValue(bannerBox.offsetTop);
        setBottomValue(
          isWindow() &&
            Number(window.getComputedStyle(bannerBox).height.split("p")[0]) +
              topValue,
          +"px"
        );
      }
    }
  }, [scrollHandler, topValue]);
  const clientHeight =
    (isDocument() && document.documentElement.clientHeight) || "";
  const cls = classNames({
    "bannerBox-left": true,
    fixed:
      scrollTop + 80 > topValue && scrollTop + clientHeight < bottomValue
        ? true
        : false,
    bottom: scrollTop + clientHeight > bottomValue ? true : false,
  });
  const renderScrollScreenPC = () => {
    return (
      <div className="manufacturing-advantage-pc">
        <div className="banner-connection" id="bannerBox">
          <div className={cls}>
            <div className="index-box">
              {list.map((item, index) => {
                return (
                  <li
                    className={bannerIndex === index ? "li" : ""}
                    key={item.title}
                  ></li>
                );
              })}
            </div>
            <div className="info-box">
              {list.map((item, index) => {
                return (
                  <div
                    className="info-box-item"
                    key={"info-box" + index}
                    style={
                      bannerIndex === index
                        ? { display: "block" }
                        : { display: "none" }
                    }
                  >
                    <div className="info-box-item-title">{item.title}</div>
                    <div className="info-box-blue-gap"></div>
                    <div className="info-box-item-content">{item.desc}</div>

                    <AuthingButton
                      mode="small"
                      onClick={() => {
                        window.open(item.downUrl);
                      }}
                    >
                      {item.downText}
                    </AuthingButton>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="bannerBox-list">
            {list.map((item, index) => {
              return (
                <div key={"bannerBox-right" + index}>
                  <div className="bannerBox-right">
                    <div className="bannerBox-right-chrild">
                      <img
                        src={item.imgUrl}
                        alt={item.alt}
                        style={{ zIndex: "2" }}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  };
  return (
    <div className="manufacturing-advantage manufacturing-column">
      {renderScrollScreenPC()}
      {/* {renderScrollScreenMobile()} */}
    </div>
  );
};
